import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, CategoryDto, DynamicFormDto, DynamicPayloadDto, EmployerDto, MemberDto, ResultListDto } from "./dto";
import { Injectable } from "@angular/core";
import { BankDepositUploadDto } from "./dto-insurance";

@Injectable({
	providedIn: 'root'
})
export class HttpInsuranceBankDepositService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/insurance/bank-deposit', authService);
	}
	public createAndValidate(fileUuid: string): Observable<BankDepositUploadDto> {
		return super.doPost(true, `/${fileUuid}/new`, {});
	}
	public get(depositId: number): Observable<BankDepositUploadDto>{
		return super.doGet(true, `/${depositId}`);
	}
	public getAll(pageIndex: number = 1, pageSize: number = 1000): Observable<ResultListDto<BankDepositUploadDto>> {
		return super.doPost(true, `/?pageIndex=${pageIndex}&pageSize=${pageSize}`, {});
	}
}
